import React from "react";
import { ShieldCheck, Truck, MapPin, Star, Sparkles } from "lucide-react";
import { heroHighlights, WHATSAPP_LINK } from "../../mock";

const iconMap = { ShieldCheck, Truck, MapPin };

const Hero = () => {
  return (
    <section
      id="inicio"
      className="relative overflow-hidden pt-36 pb-20 md:pt-44 md:pb-28"
    >
      {/* ambient glows */}
      <div className="pointer-events-none absolute -top-20 -left-20 w-[480px] h-[480px] rounded-full bg-[#ec4899]/10 blur-[120px]" />
      <div className="pointer-events-none absolute top-20 right-0 w-[420px] h-[420px] rounded-full bg-[#8b5cf6]/10 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 w-[380px] h-[380px] rounded-full bg-[#38bdf8]/10 blur-[120px]" />

      {/* floating star */}
      <Star
        className="absolute left-6 top-28 md:left-20 md:top-32 text-yellow-400 fill-yellow-400 animate-float"
        size={30}
      />

      <div className="relative max-w-5xl mx-auto px-5 text-center">
        {/* badge */}
        <div className="inline-flex items-center gap-2 rounded-full border border-[#ec4899]/40 bg-[#ec4899]/10 px-5 py-2 mb-8">
          <Sparkles size={16} className="text-[#ec4899]" />
          <span className="text-xs md:text-sm font-semibold tracking-wider text-[#f9a8d4] uppercase">
            Locação de brinquedos para festas e eventos
          </span>
        </div>

        <h1 className="font-display font-bold text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
          Brinquedos que transformam festas em{" "}
          <span className="relative inline-block text-[#f472b6]">
            momentos inesquecíveis
            <svg
              className="absolute left-0 -bottom-3 w-full"
              height="16"
              viewBox="0 0 400 16"
              preserveAspectRatio="none"
            >
              <path
                d="M2 11 C 100 3, 300 3, 398 9"
                stroke="#fbbf24"
                strokeWidth="6"
                strokeLinecap="round"
                fill="none"
              />
            </svg>
          </span>
        </h1>

        <p className="mt-10 text-gray-300 text-lg md:text-xl max-w-2xl mx-auto leading-relaxed">
          Diversão, segurança e alegria para crianças em aniversários, eventos e
          comemorações.
        </p>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#brinquedos"
            className="w-full sm:w-auto inline-flex items-center justify-center rounded-full bg-[#38bdf8] hover:bg-[#0ea5e9] text-[#06283d] font-extrabold text-base px-10 py-4 shadow-lg shadow-sky-500/25 transition-all hover:-translate-y-0.5"
          >
            VER BRINQUEDOS
          </a>
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="w-full sm:w-auto inline-flex items-center justify-center rounded-full bg-[#22c55e] hover:bg-[#1eb253] text-white font-extrabold text-base px-10 py-4 shadow-lg shadow-green-500/25 transition-all hover:-translate-y-0.5"
          >
            PEDIR ORÇAMENTO
          </a>
        </div>

        {/* highlights */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
          {heroHighlights.map((h) => {
            const Icon = iconMap[h.icon];
            return (
              <div key={h.text} className="flex items-center gap-2">
                <Icon size={18} className="text-[#22c55e]" />
                <span className="text-sm text-gray-300">{h.text}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Hero;
